// @ts-nocheck

import { css } from 'styled-components';

export default css`
  && {
    box-sizing: border-box;
    height: 1.6em;
    min-width: 1.6em;
    min-height: 1.6em;
    max-width: 1.6em;
    max-height: 1.6em;
    line-height: 1.6;
    border-radius: 50%;
    border: solid 1px ${({ theme }) => theme.grids.colors.yellow};
    background: ${({ theme }) => theme.grids.colors.black};
    margin: 0 0.6em;
    text-align: center;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
`;
